export { default } from './TagsUGCEditor';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/UGCEditors/TagsUGCEditor/index.js